import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateProductMutation } from "../../redux/api/productsApi";
import { toast } from "react-hot-toast";


import AdminProfile from "../user/AdminProfile";
import { PRODUCT_CATEGORIES } from "../../constants/constants";
import { Helmet } from "react-helmet-async";

const NewProduct = () => {
  const navigate = useNavigate();
  const [product, setProduct] = useState({
    name: "",
    description: "",
    price: "",
    category: "",
    stock: "",
    seller: "",
    details:"",
    ecoFeatures:"",
    usageTips:""
  });
  const { name, description, price, category, stock, seller, details, ecoFeatures,usageTips } = product;

  const [createProduct, { isLoading, error, isSuccess }] =
    useCreateProductMutation();

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message);
    }

    if (isSuccess) {
      toast.success("Product created");
      navigate("/admin/products");
    }
  }, [error, isSuccess, navigate]);

  const onChange = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.value });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    createProduct(product);
  };
  return (
    <AdminProfile>
      <Helmet>
        <title>Create Product</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="w-full  mt-10">
        <h1 className="text-2xl font-playfair text-[#1c1917] mb-6">
          Create New Product
        </h1>

        <form
          onSubmit={submitHandler}
          className="bg-[#f5f3ea] border border-[#e2e1d8] shadow rounded-lg p-6 space-y-6"
        >
          {/* Grid Layout for Inputs */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-[#1c1917] font-sourcesans mb-1">
                Name
              </label>
              <input
                type="text"
                name="name"
                value={name}
                onChange={onChange}
                required
                className="w-full px-4 py-2 border border-[#e2e1d8] rounded-md bg-white focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-[#1c1917] font-sourcesans mb-1">
                Price ($)
              </label>
              <input
                type="number"
                name="price"
                value={price}
                onChange={onChange}
                required
                min="0"
                className="w-full px-4 py-2 border border-[#e2e1d8] rounded-md bg-white focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-[#1c1917] font-sourcesans mb-1">
                Stock
              </label>
              <input
                type="number"
                name="stock"
                value={stock}
                onChange={onChange}
                required
                min="0"
                className="w-full px-4 py-2 border border-[#e2e1d8] rounded-md bg-white focus:border-[#BC3F4A] focus:ring-[#BC3F4A] 
                focus:outline-none text-sm"
              />
            </div>
                     
            <div className="flex items-end">

            <select
             className="w-full px-4 py-2 border border-[#e2e1d8] rounded-md bg-white focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
              id="category_field"
              name="category"
              value={category}
              onChange={onChange}
            >
              {PRODUCT_CATEGORIES?.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-[#1c1917] font-sourcesans mb-1">
                Seller
              </label>
              <input
                type="text"
                name="seller"
                value={seller}
                onChange={onChange}
                required
                className="w-full px-4 py-2 border border-[#e2e1d8] rounded-md bg-white focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
              />
            </div>
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-medium text-[#1c1917] font-sourcesans mb-1">
              Description
            </label>
            <textarea
              name="description"
              value={description}
              onChange={onChange}
              required
              rows="4"
              className="w-full px-4 py-2 border border-[#e2e1d8] rounded-md bg-white focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
            />
          </div>
          <div>
              <label className="block text-sm font-medium text-[#1c1917] font-sourcesans mb-1">
                Details
              </label>
              <textarea
                type="text"
                name="details"
                value={details}
                onChange={onChange}
                required
                rows="4"
                className="w-full px-4 py-2 border border-[#e2e1d8] rounded-md bg-white focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#1c1917] font-sourcesans mb-1">
                Eco Features
              </label>
              <textarea
                type="text"
                name="ecoFeatures"
                value={ecoFeatures}
                onChange={onChange}
                required
                rows="4"
                className="w-full px-4 py-2 border border-[#e2e1d8] rounded-md bg-white focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#1c1917] font-sourcesans mb-1">
                Usage Tips
              </label>
              <textarea
                type="text"
                name="usageTips"
                value={usageTips}
                onChange={onChange}
                required
                rows="4"
                className="w-full px-4 py-2 border border-[#e2e1d8] rounded-md bg-white focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
              />
            </div>

          {/* Image Upload */}
          {/* <div>
            <label className="block text-sm font-medium text-[#1c1917] font-sourcesans mb-2">
              Upload Images
            </label>
            <div className="w-full border-2 border-dashed border-[#e2e1d8] rounded-md p-6 text-center cursor-pointer hover:border-[#BC3F4A] transition">
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleFileChange}
                className="hidden"
                id="file-upload"
              />
              <label
                htmlFor="file-upload"
                className="cursor-pointer text-sm text-[#8a4b32]"
              >
                Drag & drop or click to upload
              </label>
            </div> */}

          {/* Preview Images */}
          {/* {preview.length > 0 && (
              <div className="mt-4 flex flex-wrap gap-3">
                {preview.map((img, idx) => (
                  <img
                    key={idx}
                    src={img}
                    alt="preview"
                    className="w-20 h-20 object-cover rounded-md border border-[#e2e1d8]"
                  />
                ))}
              </div>
            )}
          </div> */}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-3 px-4 rounded-md bg-[#BC3F4A] text-white font-playfair hover:bg-[#a3323b] transition disabled:opacity-50"
          >
            {isLoading ? "Creating..." : "Create Product"}
          </button>
        </form>
      </div>
    </AdminProfile>
  );
};

export default NewProduct;
